<script>
import SummaryOnBoardCrewPieChart from "@/components/dashboard/number-of-management/SummaryOnBoardCrewPieChart.vue";
import SummaryTotalCrewBarGraph from "@/components/dashboard/number-of-management/SummaryTotalCrewBarGraph.vue";
import {VesselService} from "@/services/VesselService";
import { toBlob } from 'dom-to-image-more';
import {permissionMixin} from "@/mixins/permissionMixins";


export default {
  name: "SummaryPerManningGraphContainer",
  mixins: [permissionMixin],
  data() {
    const series = this.data.map(item => {
      return item.totalOnboardCrewCount;
    });

    return {
      activeTab : 'pie-chart-per-manning-company',
      series: series,
      chartOptions: {
        plotOptions: {
          pie: {
            customScale: 0.9,
          }
        },
        chart: {
          type: "pie",
          height: 1180,
        },
        labels: [],

        legend: {
          height : 1180,
          position: 'left',
          fontFamily: 'Helvetica, Arial',
          fontWeight: 'bold',
          markers: {
            width: 8,
            height: 8,
            radius: 8,
            offsetX: -5,
          },
          formatter: function(seriesName, opts) {
            return seriesName + ": " + '<strong>' + opts.w.globals.series[opts.seriesIndex] + '</strong>';
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize : '20px',
            fontFamily: 'Helvetica, Arial, sans-serif',
            fontWeight: 'bold',
            colors: new Array(series.length).fill('#fff'),
          },
          background: {
            enabled: true,
            foreColor: '#000',
            padding: 4,
            borderRadius: 2,
            borderWidth: 1,
            borderColor: '#fff',
            opacity: 0.9,
            dropShadow: { enabled: false }
          },
          dropShadow: { enabled: false },
          formatter: function(seriesName, opts) {
            return opts.w.globals.series[opts.seriesIndex];
          }
        },
        tooltip: {
          enabled: true,
          style : { color : '#fff' },
        },
      },
    }
  },
  components: {SummaryTotalCrewBarGraph, SummaryOnBoardCrewPieChart},
  props : {
    data : {
      type : Array,
      default : []
    }
  },
  methods: {
    async getGraphImage() {
      swal.fire({
        'title': `Exporting Summary Per Manning Company OnBoard`,
        'text': "Please wait...",
        'imageUrl': "https://img.icons8.com/color/400/pie-chart--v1.png",
        'imageWidth': 100,
        'imageHeight': 100,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false
      })
      swal.showLoading()

      const blob = await toBlob(this.$refs["pie-chart-container"], {
        pixelRatio: 2,
        backgroundColor: 'white'
      });

      const formData = new FormData();
      formData.append("chart_image", blob, "chart.png");
      formData.append("report_type", 'Summary Per Manning Company OnBoard');

      const printResponse = await VesselService.printSummaryOfManagingVesselGraph(formData);
      swal.close()
      let url = window.URL.createObjectURL(new Blob([printResponse.data],{type:'application/pdf'}))
      let filename=`summary_per_manning_company_onboard_${Date.now()}.pdf`;
      const link = document.createElement('a');
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        this.setPieContainerHeight()
      }, 100);
    },
  },
  created() {
    this.chartOptions.labels = this.data.map(item => {
      return item.alias.toUpperCase();
    });
  },
}
</script>

<template>
<!--  <div class="col-12">-->
    <div class="card shadow-sm">
      <div class="card-body">
<!--        <div class="tab-content" id="pills-tabContent">-->
<!--          <div class="tab-pane fade show active" id="pills-onboard" role="tabpanel" aria-labelledby="pills-onboard-tab">-->
<!--            <div>-->
<!--              <ul class="nav nav-tabs" id="pills-tab" role="tablist">-->
<!--                <li class="nav-item" role="presentation">-->
<!--                  <button class="main-tabs nav-link text-uppercase font-weight-bold" :class="{'active' : activeTab === 'pie-chart-per-manning-company'}" id="pills-onboard-graph-tab" data-toggle="pill" data-target="#pills-onboard-graph" type="button" role="tab" aria-controls="pills-onboard-graph" aria-selected="false">Pie Graph Per Manning Company</button>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->


            <div class="row mt-2">
              <div class="col-12" v-if="['k-line-persons', 'k-line-persons2'].includes(user.roles_permissions?.roles[0]) === false">
                <button id="downloadSummaryOnBoardCrewChart" class="cursor-pointer float-right ml-2 e-btn e-btn-blue-gray force-white-all"
                        @click="getGraphImage()"
                >
                  <font-awesome-icon class="mr-1" icon="download"/>
                  Download Graph
                </button>
              </div>
            </div>
            <div class="pie-chart-container" id="pie-chart-container">
              <div class="text-center">
                <h4 class="font-weight-bold text-uppercase">Onboard Crew</h4>
              </div>
              <div>

              </div>
              <div>

              </div>
              <div ref="pie-chart-container">
                <apexchart
                  type="pie"
                  height="auto"
                  :options="chartOptions"
                  :series="series"
                ></apexchart>
              </div>
            </div>
<!--          </div>-->
<!--        </div>-->
      </div>
    </div>
<!--  </div>-->
</template>

<style scoped>
.nav-tabs .nav-link.active {
  color: #d3313c !important;
}

.nav-pills .nav-link.active {

  background-color: #d3313c !important;
  color: white !important;
}
</style>
